import * as types from "../constants/survey_constants";

const initialState = {
  surveys: [],
  currentSurvey: null,
  responses: [],
  analytics: null,
  surveyError: null,
  message: null,
};

const surveyReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.GET_SURVEYS_SUCCESS:
      return {
        ...state,
        surveys: payload?.surveys || [],
        surveyError: null,
      };

    case types.CREATE_SURVEY_SUCCESS:
    case types.UPDATE_SURVEY_SUCCESS:
      return {
        ...state,
        currentSurvey: payload?.survey || null,
        message: payload ? "Survey saved successfully" : null,
        surveyError: null,
      };

    case types.GET_SURVEY_RESPONSES_SUCCESS:
      return {
        ...state,
        currentSurvey: payload?.survey || state.currentSurvey,
        responses: payload?.responses || [],
        surveyError: null,
      };

    case types.GET_SURVEY_ANALYTICS_SUCCESS:
      return {
        ...state,
        analytics: payload?.analytics || null,
        surveyError: null,
      };

    case types.GET_SURVEYS_FAILURE:
    case types.CREATE_SURVEY_FAILURE:
    case types.UPDATE_SURVEY_FAILURE:
    case types.GET_SURVEY_RESPONSES_FAILURE:
    case types.GET_SURVEY_ANALYTICS_FAILURE:
      return {
        ...state,
        surveyError: payload || null,
      };

    default:
      return state;
  }
};

export default surveyReducer;
